import areAllChildrenHidden from './are-all-children-hidden';
import areChildrenEnabled from './are-children-enabled';
import areChildrenEnabledForNode from './are-children-enabled-for-node';
import hasDocumentAdditives from './has-document-additives';
import hasElementAdditives from './has-element-additives';
import hasElementAttribute from './has-element-attribute';

export default {
  areAllChildrenHidden,
  areChildrenEnabled,
  areChildrenEnabledForNode,
  hasDocumentAdditives,
  hasElementAdditives,
  hasElementAttribute,
};
